import * as React from 'react'
import {AttachmentsViewer} from '../../core/components/Controls/Attachments/AttachmentsViewer2'
import {CsSelector} from '../../core/components/Controls/CsSelector'
import {CoordinateSystem} from '../../core/enums/CoordinateSystem'
import {AttachmentInfo, AttachmentInfos} from '../../core/interfaces/models'
import {Feature} from '../../core/models'
import {LocationSelector} from '../App/LocationSelector'
import DatePicker from 'react-datepicker'

export interface ILayerNames {
  DataCS: CoordinateSystem
  PlanName: string
  LocationId?: number
  PlanDate: Date
  Cp1251: boolean

  Expanded: boolean

  KvLayer: string
  StrPolygonEnd: string

  OSLineLayer: string

  TrotoLayer: string

  OTBlockName: string
  OTNomerTag: string
  OTKotaTag: string
  OTCreatedTag: string
  OTDescTag: string
  file?: AttachmentInfo
  location?: Feature
  settlement?: Feature
}

interface Props extends ILayerNames {
  onChange: (props: ILayerNames) => void
}

export const StreetImportParameterSelector = (props: Props) => {
  const getLocationSelector = () => {
    return (
      <LocationSelector
        selectedLocation={props.location}
        selectedSettlemet={props.settlement}
        onSettlementsChange={(locs, settlement?: Feature, location?: Feature) =>
          props.onChange({...props, settlement, location})
        }
      />
    )
  }

  const getProjectionSelector = (): JSX.Element => {
    return (
      <CsSelector
        selected={props.DataCS}
        onChange={s => props.onChange({...props, DataCS: s})}
        className="form-control"
      />
    )
  }
  const getAttachmentsControl = () => {
    const adds: AttachmentInfos = {}
    if (props.file) {
      adds[props.file.name] = props.file
    }
    return (
      <div style={{margin: '5px'}}>
        <AttachmentsViewer
          attachments={{}}
          deletes={{}}
          updates={{}}
          adds={adds}
          acceptTypes={'.dxf'}
          maxNumber={1}
          onAttachmentsChange={changes => {
            const addedFiles = Object.keys(changes.adds)
            let file: AttachmentInfo | undefined
            if (addedFiles.length > 0) {
              file = changes.adds[addedFiles[0]]
            }
            props.onChange({...props, file: file})
          }}
          feature={new Feature({})}
          uploadToArchive={false}
        ></AttachmentsViewer>
      </div>
    )
  }
  const getContainer = (content: JSX.Element, title: string | JSX.Element, margin?: string): JSX.Element => {
    return (
      <div style={{margin, display: 'flex'}}>
        <div style={{minWidth: '40%', maxWidth: '40%', display: 'flex', alignItems: 'center'}}>{title}</div>
        {content}
      </div>
    )
  }
  const getDateEditingDatePicker = (date: Date): JSX.Element => {
    return (
      <DatePicker
        dateFormat={'dd.MM.yyyy'}
        className="form-control"
        selected={date}
        onChange={v => {
          const newDate = new Date(v!)
          ;[0, 0, 0, 0].forEach((v, i) => {
            if (v == undefined) {
              return
            }
            if (i == 0) {
              newDate.setHours(v)
            } else if (i == 1) {
              newDate.setMinutes(v)
            } else if (i == 2) {
              newDate.setSeconds(v)
            } else if (i == 3) {
              newDate.setMilliseconds(v)
            }
          })
          newDate.setMinutes(-newDate.getTimezoneOffset())
          props.onChange({...props, PlanDate: newDate})
        }}
        isClearable={false}
        showYearDropdown
      />
    )
  }
  const getPlanNaming = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input
          className="form-control"
          style={{margin: '0 10px 0 0'}}
          value={props.PlanName}
          onChange={e => props.onChange({...props, PlanName: e.target.value})}
        ></input>
        {getDateEditingDatePicker(props.PlanDate)}
      </div>
    )
  }
  const getEncodingSelector = () => {
    return (
      <input
        type="checkbox"
        checked={props.Cp1251}
        onChange={() => props.onChange({...props, Cp1251: !props.Cp1251})}
      ></input>
    )
  }

  const getExpandingLink = () => {
    return (
      <div style={{minHeight: '40px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <a href="javascript:;" onClick={() => props.onChange({...props, Expanded: !props.Expanded})}>
          {props.Expanded ? 'По - малко настройки' : 'Повече настройки'}
        </a>
      </div>
    )
  }
  const getLayerMappings = () => {
    const sectionStyle: React.CSSProperties = {
      border: '1px solid #565656',
      borderRadius: '5px',
      boxSizing: 'border-box',
      marginTop: '5px'
    }
    const sectionStyle2: React.CSSProperties = {
      boxSizing: 'border-box',
      padding: '8px'
    }
    const sectionHeaderStyle: React.CSSProperties = {
      padding: '8px',
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'cadetblue'
    }
    return (
      <div>
        <div style={sectionStyle}>
          <div style={sectionHeaderStyle}>Улична регулация полигони</div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.KvLayer}
                onChange={e => props.onChange({...props, KvLayer: e.target.value})}
              />,
              'Слой за квартали'
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.StrPolygonEnd}
                onChange={e => props.onChange({...props, StrPolygonEnd: e.target.value})}
              />,
              'Слой -затваряне на улична регулация (пунктир)'
            )}
          </div>
        </div>
        <div style={sectionStyle}>
          <div style={sectionHeaderStyle}>Линии</div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.OSLineLayer}
                onChange={e => props.onChange({...props, OSLineLayer: e.target.value})}
              />,
              'Слой - Осова линия'
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.TrotoLayer}
                onChange={e => props.onChange({...props, TrotoLayer: e.target.value})}
              />,
              'Слой - Бордюрна регулация'
            )}
          </div>
        </div>

        <div style={sectionStyle}>
          <div style={sectionHeaderStyle}>Осова точка</div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.OTBlockName}
                onChange={e => props.onChange({...props, OTBlockName: e.target.value})}
              />,
              'Име на блок с данни за осова точка'
            )}

            {getContainer(
              <input
                className="form-control"
                value={props.OTNomerTag}
                onChange={e => props.onChange({...props, OTNomerTag: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за номер на точката</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.OTKotaTag}
                onChange={e => props.onChange({...props, OTKotaTag: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за височина на точката</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.OTCreatedTag}
                onChange={e => props.onChange({...props, OTCreatedTag: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за създател на точката</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.OTDescTag}
                onChange={e => props.onChange({...props, OTDescTag: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за описание на точката</span>
            )}
          </div>
        </div>
      </div>
    )
  }
  return (
    <div>
      {getContainer(getLocationSelector(), 'Изберете местност', `10px 0px`)}
      {getContainer(getAttachmentsControl(), 'Прикачете файл', `10px 0px`)}
      {getContainer(getProjectionSelector(), 'Координатна система на данните от файла', `10px 0px`)}
      {getContainer(getPlanNaming(), 'Име и дата на плана/изменението', `10px 0px`)}
      {getExpandingLink()}
      {props.Expanded ? getLayerMappings() : null}
    </div>
  )
}
